import React from 'react';
import { Box, chakra } from '@chakra-ui/react';

const PropLabel = chakra('div', {
  baseStyle: {
    color: 'gray.500',
    fontWeight: '500',
  },
});
const PropValue = chakra('div', {
  baseStyle: {
    color: 'black',
  },
});

export interface PropertyProps {
  label: React.ReactNode;
  /**
   * Test id is appended to the value
   */
  testId?: string;
}

export const Property: React.FC<PropertyProps> = ({
  label,
  testId,
  children,
}) => (
  <Box>
    <PropLabel>{label}</PropLabel>
    <PropValue data-testid={testId}>{children}</PropValue>
  </Box>
);
